$().ready(function(){
	var myTextExtraction = function(node) {  
	    // extract data from markup and return it 
	    var sortername = node.getAttribute("class");
	    if(sortername == "order-type" ){
	    	return $(node).attr("sorterAttr");
	    }else{
	    	return $(node).text();
	    }
	}
	
	if($('#tablesorter tr').length > 1){ //first row is for header
		$("#tablesorter").tablesorter({ 
			dateFormat : "uk",
			sortList: [[2,1]],
			headers:{
	 			1 : { sorter: 'text' },
				2 : { sorter: "shortDate", dateFormat: "ddmmyyyy" },
				3 : { sorter: 'digit' },
				4 : { sorter: 'text' },
				5 : { sorter: false },
				6 : { sorter: false }
			},
			textExtraction: myTextExtraction
		});
	}
	
	$("#selStatus").val('${param.status}').attr('selected', true);

	$(".online-checkin").click(showOnlineCheckin);  
});

function cancelReservation(orderId) {
	if (orderId > 0) {
		var winstatus = 'scrollbars=yes,menubar=no,height=700,width=800,resizable=yes,toolbar=no,location=no,status=no';
		var detailwin=null;
		
		var url = URL_MAPPING.resolveUrl('/order/detailcancel');

		url = url+'?id=' + orderId;
		
		if (detailwin == null || detailwin.closed)
			detailwin = window.open(url,'resDetailWindow',winstatus);
		 else
		 	detailwin.location = url;
		
		if (!detailwin.opener)
			detailwin.opener = self;
		
		detailwin.focus();
	}
	
	return false;
}

function buyReservation(orderId) {
	if (orderId > 0) {
		var winstatus = 'scrollbars=yes,menubar=no,height=1024,width=900,resizable=yes,toolbar=no,location=no,status=no';
		var detailwin=null;
		
		var url = URL_MAPPING.resolveUrl('/order/detail');
		url = url+'?id=' + orderId;
		
		if (detailwin == null || detailwin.closed)
			detailwin = window.open(url,'resDetailWindow',winstatus);
		 else
		 	detailwin.location = url;
		
		if (!detailwin.opener)
			detailwin.opener = self;
		
		detailwin.focus();
	}
	
	return false;
}

function showReservation(pnr,orderId) {
	if (orderId > 0) {
		var winstatus = 'scrollbars=yes,menubar=no,height=1024,width=900,resizable=yes,toolbar=no,location=no,status=no';
		var detailwin=null;
		
		if (pnr.indexOf('RAC') == 0){
			var url = URL_MAPPING.resolveUrl('/order/carOrderDetail');
			url = url+'?id=' + orderId+"&showOnly=true";
		}
		else if (pnr.indexOf('HTL') == 0){
			var url = URL_MAPPING.resolveUrl('/order/hotelOrderDetail');
			url = url+'?id=' + orderId+"&showOnly=true";
		}
		else if (pnr.indexOf('TRF') == 0){
			var url = URL_MAPPING.resolveUrl('/order/transferOrderDetail');
			url = url+'?id=' + orderId+"&showOnly=true";
		}
		else {
			var url = URL_MAPPING.resolveUrl('/order/detail');
			url = url+'?id=' + orderId+"&showOnly=true";
		}
		if (detailwin == null || detailwin.closed)
			detailwin = window.open(url,'resDetailWindow',winstatus);
		 else
		 	detailwin.location = url;
		
		if (!detailwin.opener)
			detailwin.opener = self;
		
		detailwin.focus();
	}
}

function showOnlineCheckin(event)
{
	event.stopPropagation();
	return true;
}

function wrapperBuyReservation(id, warn) {
	if (warn) {
		alert('<fmt:message key="warn.ticket.reservation" />');
		return;
	} else {
		buyReservation(id);
	}
}

function wrapperBuyTourReservation(id, warn) {
	if (warn) {
		alert('<fmt:message key="warn.ticket.reservation" />');
		return;
	} else {
		buyTourReservation(id);
	}
}

